module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'subActions'
	],

	formMapping: {
		cols: [
			[
				{ type: 'buttons', buttons: [
					{ buttonType: 'showInsert', context: 'client', icon: 'fi fi-client' }
				] }
			]
		]
	}
};
